import { Timestamp } from 'firebase/firestore';

export class Model {
  model_id: string = '';
  user_id: string = '';
  name: string = '';
  description: string | null = null;
  date_of_birth: Date = new Date();
  age: string | null = null;
  gender: string = '';
  phone_number: string | null = null;
  email: string = '';
  profile_image_url: string | null = null;
  profile_banner_url: string | null = null;
  twitter_url: string | null = null;
  instagram_url: string | null = null;
  city: string | null = null;
  province: string | null = null;
  country: string | null = null;
  tags: string = '';
  likesCount: number = 0;
  viewsCount?: number = 0;
  imagesCount?: number;
  videosCount?: number;
  created_at: Date | null = null;

  constructor(init?: Partial<Model>) {
    Object.assign(this, init);
  }

  static fromFirestore(id: string, data: any): Model {
    let parsedDob: Date = new Date(0); // Default to epoch as "no date"
    if (data.date_of_birth) {
      // Check for Firestore Timestamp (has toDate method) or seconds/nanoseconds structure
      if (typeof data.date_of_birth.toDate === 'function') {
        parsedDob = data.date_of_birth.toDate();
      } else if (data.date_of_birth.seconds !== undefined) {
        // Raw Firestore timestamp object
        parsedDob = new Date(data.date_of_birth.seconds * 1000);
      } else if (data.date_of_birth instanceof Date) {
        parsedDob = data.date_of_birth;
      } else {
        const parsed = new Date(data.date_of_birth);
        if (!isNaN(parsed.getTime())) {
          parsedDob = parsed;
        }
      }
    }

    return new Model({
      model_id: id,
      user_id: data.user_id ?? '',
      name: data.name ?? '',
      description: data.description ?? null,
      date_of_birth: parsedDob,
      age: data.age ?? null,
      gender: data.gender ?? '',
      phone_number: data.phone_number ?? null,
      email: data.email ?? '',
      profile_image_url: data.profile_image_url ?? null,
      profile_banner_url: data.profile_banner_url ?? null,
      twitter_url: data.twitter_url ?? null,
      instagram_url: data.instagram_url ?? null,
      city: data.city ?? null,
      province: data.province ?? null,
      country: data.country ?? null,
      tags: data.tags ?? '',
      likesCount: typeof data.likesCount === 'number' ? data.likesCount : 0,
      viewsCount: typeof data.viewsCount === 'number' ? data.viewsCount : 0,
      imagesCount: typeof data.imagesCount === 'number' ? data.imagesCount : undefined,
      videosCount: typeof data.videosCount === 'number' ? data.videosCount : undefined,
      created_at: data.created_at instanceof Timestamp
        ? data.created_at.toDate()
        : data.created_at?.seconds !== undefined
          ? new Date(data.created_at.seconds * 1000)
          : data.created_at instanceof Date
            ? data.created_at
            : data.created_at
              ? new Date(data.created_at)
              : null
    });
  }

  toFirestore() {
    return {
      user_id: this.user_id,
      name: this.name,
      description: this.description,
      date_of_birth: this.date_of_birth,
      age: this.age,
      gender: this.gender,
      phone_number: this.phone_number,
      email: this.email,
      profile_image_url: this.profile_image_url,
      profile_banner_url: this.profile_banner_url,
      twitter_url: this.twitter_url,
      instagram_url: this.instagram_url,
      city: this.city,
      province: this.province,
      country: this.country,
      tags: this.tags,
      created_at: this.created_at
    };
  }
}